import { render, staticRenderFns } from "./SupplierCommodityCreateUpdate.vue?vue&type=template&id=0c329156"
import script from "./SupplierCommodityCreateUpdate.vue?vue&type=script&lang=js"
export * from "./SupplierCommodityCreateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports